module.exports = __webpack_public_path__ + "img/AtaMuhammad.b0074d66.jpg";